import React, {useEffect, useState} from "react";
import {
    checkPermissionMasterParentStartingTree,
    getDocumentLabel, getGreekCurrencyFormat,
    isEmpty
} from "../../../../../_helpers/commonFunctions";
import {Badge, Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import {LuPackageCheck, LuPackageOpen, LuPackagePlus} from "react-icons/lu";
import {useDispatch, useSelector} from "react-redux";
import {
    defaultEditFixedAssetAdditionalImprovement,
    defaultNewFixedAsset,
    setNewFixedAsset
} from "../../../../../_reducers/DataPanel/FixedAssets/fixedAssetsSlice";
import axios from "axios";
import {toast} from "react-toastify";
import Input from "../../../../common/Input";
import Dropdown from "../../../../primer/Dropdown";
import moment from "moment";
import DateBox from "../../../../primer/DateBox";
import {updateFixedAsset} from "../../../../../_apis/api";
import {validateFixedAsset} from "../../../../../_helpers/validator";
import {openFixedAssetLocal, openTabByType} from "../../../../../_helpers/tabOpeners";

const FixedAssetBuysAction = ({rowData, permissionsData, setParentShow}) => {
    // permissionsData gets passed through for performance purposes
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const SALES = useSelector((state) => state.SALES);
    const BUYS = useSelector((state) => state.BUYS);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const ACTIVE_MAIN_TAB = useSelector((state) => state.ACTIVE_MAIN_TAB);

    const [aiModal, setAiModal] = useState(false);

    const [loadingUpdateAsset, setLoadingUpdateAsset] = useState(false);
    const [loadingAssets, setLoadingAssets] = useState(false);
    const [assets, setAssets] = useState([]);
    const [filter, setFilter] = useState("");
    const [selectedAsset, setSelectedAsset] = useState("");
    const selectedAssetObject = selectedAsset ? assets.find((el) => el._id === selectedAsset) : null;

    const [newAI, setNewAI] = useState({...defaultEditFixedAssetAdditionalImprovement});

    const aiOptions = [
        { label: "Προσθήκη", value: "addition" },
        { label: "Βελτίωση", value: "improvement" }
    ]

    useEffect(() => {
        if (aiModal) {
            setNewAI({
                ...defaultEditFixedAssetAdditionalImprovement,
                date: moment(BUYS.editBuys.date).toDate(),
                description: rowData.name,
                correlatedBuy: BUYS.editBuys._id,
                correlatedBuyLabel: getDocumentLabel(BUYS.editBuys),
                correlatedBuyRowNumber: rowData.no,
            })
        }
    }, [aiModal])

    useEffect(() => {
        if (selectedAssetObject) {
            let am = selectedAssetObject.vatIsIncluded ? rowData.totalValue : rowData.netValue;
            if (BUYS.editBuys?.affects_supplier === "-") am = -am;
            setNewAI({
                ...newAI,
                amount: am,
            })
        }
    }, [selectedAssetObject])

    const toNewFixedAsset = () => {
        dispatch(setNewFixedAsset({
            ...defaultNewFixedAsset,
            dateFrom: BUYS.editBuys.date,
            quantity: rowData.quantity || 1,
            name: rowData.name || "",
            acquisitionCost: rowData.netValue || 0,
            correlatedBuy: BUYS.editBuys._id,
            correlatedBuyLabel: getDocumentLabel(BUYS.editBuys),
            correlatedBuyRowNumber: rowData.no,
        }))
        dispatch(openTabByType("new-fixed-asset", TABS_DATA));
    }

    const toViewFixedAsset = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/fixedassets/get-asset-by-id`, {
            params: {
                company: company.id,
                id: rowData.correlatedFixedAsset,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(openFixedAssetLocal(res.data.data, TABS_DATA));
            } else {
                toast.error("Το πάγιο δεν βρέθηκε.");
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση παγίου.");
        })
    }

    const toAdditionalImprovement = () => {
        setAiModal(true);
        axios.get(`${process.env.REACT_APP_API_URL2}/fixedassets/fetch-active-assets`, {
            params: {
                company: company.id,
            }
        }).then((res) => {
            if (res.data.status === "200") setAssets(res.data.data);
            setLoadingAssets(false);
        }).catch((err) => {
            setLoadingAssets(false);
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση παγίων.");
        })
    }

    const renderActionCell = (asset) => {
        if (asset._id === selectedAsset) {
            return <Badge bg={"success"} style={{userSelect: "none"}}>Επιλεγμένο</Badge>
        } else {
            return <Badge bg={"dark"} style={{cursor: "pointer", userSelect: "none"}} onClick={() => setSelectedAsset(asset._id)}>Επιλογή</Badge>
        }
    }

    const onSave = () => {
        const cloneAsset = structuredClone(selectedAssetObject);
        const ais = cloneAsset?.additionalImprovements || [];
        ais.push(newAI);
        ais.forEach((ai, idx) => {
            ai.no = String(idx + 1);
        })
        cloneAsset.additionalImprovements = ais;
        const validationResponse = validateFixedAsset(cloneAsset);
        if (!validationResponse.success) return toast.error(validationResponse.message);

        dispatch(updateFixedAsset(cloneAsset, SALES, BUYS, setLoadingUpdateAsset, () => {
            setAiModal(false);
            setParentShow(false);
        }));
    }

    return (
        <React.Fragment>
            {(TABS_DATA[ACTIVE_MAIN_TAB].tabType === "edit-buys" && checkPermissionMasterParentStartingTree("fixedassets", permissionsData) === true) && (
                <React.Fragment>
                    {isEmpty(rowData?.correlatedFixedAsset) ? (
                        <div style={{textAlign: "center"}}>
                            <Button style={{pointerEvents: "auto", width: "100%"}}
                                    size={"sm"} variant={"primary"} backdrop={"static"} onClick={() => toNewFixedAsset()}>
                                <LuPackagePlus size={18} /> Δημιουργία παγίου
                            </Button>
                            <Button style={{pointerEvents: "auto", width: "100%"}}
                                    size={"sm"} variant={"primary"} backdrop={"static"} className={"mt-2"} onClick={() => toAdditionalImprovement()}>
                                <LuPackageOpen size={18} /> Προσθήκη / Βελτίωση παγίου
                            </Button>

                            <Modal show={aiModal} onHide={() => setAiModal(false)} backdrop={"static"} dialogClassName={"modal65PercentWidth"}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Προσθήκη / Βελτίωση παγίου</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {loadingAssets ? (
                                        <span>Παρακαλώ περιμένετε...</span>
                                    ) : (
                                        <React.Fragment>
                                            <Row>
                                                <Col md={12}>
                                                    <Input
                                                        name={"filter"}
                                                        label={"Όνομα/Κωδικός Παγίου"}
                                                        value={filter}
                                                        onChange={(e) => setFilter(e.target.value)}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className={"mt-2"}>
                                                <Col md={12}>
                                                    {assets.length > 0 && (
                                                        <table className={"simpleClassicTable"}>
                                                            <thead>
                                                            <tr>
                                                                <th>Κωδικός Παγίου / Χειροκίνητος Κωδικός</th>
                                                                <th>Όνομα</th>
                                                                <th>Αξία κτήσης</th>
                                                                <th>Αποσβεσμένο ποσό</th>
                                                                <th>Αναπόσβεστο ποσό / Υπόλοιπο</th>
                                                                <th>Επιλογή</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {assets.filter((el) => {
                                                                if (filter) {
                                                                    if (String(el.name).includes(filter) || String(el.systemCode).includes(filter) || String(el.manualCode).includes(filter)) {
                                                                        return el;
                                                                    } else {
                                                                        return null;
                                                                    }
                                                                } else {
                                                                    return el;
                                                                }
                                                            }).filter(Boolean).map((asset, idx) => (
                                                                <tr key={`fasa-${idx}`}>
                                                                    <td>{asset.systemCode + (asset.manualCode ? ` / ${asset.manualCode}` : "")}</td>
                                                                    <td>{asset.name}</td>
                                                                    <td>{getGreekCurrencyFormat(asset.acquisitionCost)}</td>
                                                                    <td>{getGreekCurrencyFormat(asset.accumulatedDepreciation)}</td>
                                                                    <td>{getGreekCurrencyFormat(asset.balance)}</td>
                                                                    <td>{renderActionCell(asset)}</td>
                                                                </tr>
                                                            ))}
                                                            </tbody>
                                                        </table>
                                                    )}
                                                </Col>
                                            </Row>
                                            {selectedAssetObject && (
                                                <Row className={"mt-2 border-top"}>
                                                    <div className={"text-muted mt-1"}><i>Στοιχεία Προσθήκης / Βελτίωσης</i></div>
                                                    <Col md={3}>
                                                        <Dropdown
                                                            name={"type"}
                                                            label={"Τύπος"}
                                                            options={aiOptions}
                                                            defaultValue={aiOptions.find((el) => el.value === newAI.type)}
                                                            key={newAI.type}
                                                            onChange={(e) => setNewAI({...newAI, type: e.value})}
                                                        />
                                                    </Col>
                                                    <Col md={3}>
                                                        <DateBox
                                                            name={"date"}
                                                            label={"Ημερομηνία"}
                                                            selected={newAI.date}
                                                            allowOtherYears={true}
                                                            onChange={(e) => {
                                                                if (moment(e).isValid()) {
                                                                    setNewAI({...newAI, date: moment(e).toDate()})
                                                                } else {
                                                                    setNewAI({...newAI, date: moment().toDate()})
                                                                }
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col md={3}>
                                                        <Input
                                                            name={"description"}
                                                            label={"Περιγραφή"}
                                                            value={newAI.description}
                                                            onChange={(e) => setNewAI({...newAI, description: e.target.value})}
                                                        />
                                                    </Col>
                                                    <Col md={3}>
                                                        <Input
                                                            label={"Ποσό"}
                                                            name={"amount"}
                                                            disabled={true}
                                                            value={getGreekCurrencyFormat(newAI.amount)}
                                                        />
                                                    </Col>
                                                </Row>
                                            )}
                                        </React.Fragment>
                                    )}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="outline-primary" onClick={() => setAiModal(false)}>
                                        Κλείσιμο
                                    </Button>
                                    <Button variant="primary" onClick={() => onSave()} disabled={loadingUpdateAsset}>
                                        Αποθήκευση {loadingUpdateAsset && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    ) : (
                        <div style={{textAlign: "center"}}>
                            <Button style={{pointerEvents: "auto", width: "100%"}}
                                    size={"sm"} variant={"primary"} backdrop={"static"} onClick={() => toViewFixedAsset()}>
                                <LuPackageCheck size={18} /> Προβολή συσχετιζόμενου παγίου
                            </Button>
                        </div>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default FixedAssetBuysAction;
